import React from 'react';
import { FC } from 'react';

export const IterGen: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vQevCb4htSI33K0PQEYKm4WngOHJrSgXwH16hb6KGXSmH4Rxp1ytUfqvsfW8ghD-wEYHGenqUqvWrxd/embed?start=false&loop=false&delayms=3000"
                width="1200" height="675">
                </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};